import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '@assets/img/icons/arrow-down.svg?react';
import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import { type CompareResourceLevelUpProps } from '@common/types/components';
import { H3, StringXSmall } from '@components/Typography/Typography';
import { ResourceImage } from '@components/ui/ResourceImage/ResourceImage';

import tapPng from '/img/tap.png';
import tapWebp from '/img/tap.webp';
import timerPng from '/img/timer.png';
import timerWebp from '/img/timer.webp';

const CompareResourceLevelUp: FC<CompareResourceLevelUpProps> = ({
  resource,
  compaireKind,
  now,
  next,
}) => {
  const { t } = useTranslation();
  const text: Record<'mining' | 'loan' | 'tap', string> = {
    mining: t('Mining per hour'),
    loan: t('Filling time'),
    tap: t('Units per tap'),
  };

  return (
    <div className="flex flex-col items-center">
      {compaireKind === 'mining' ? (
        <ResourceImage size="4.5rem" kind={resource} />
      ) : (
        <div className="w-[4.5rem] h-[4.5rem]">
          <picture className="w-full h-full">
            <source
              className="w-full h-full"
              srcSet={compaireKind === 'loan' ? timerWebp : tapWebp}
              type="image/webp"
            />
            <img
              className="w-full h-full"
              src={compaireKind === 'loan' ? timerPng : tapPng}
              alt="task"
            />
          </picture>
        </div>
      )}
      <StringXSmall weight="regular" className="text-white/40 mb-1">
        {text[compaireKind]}
      </StringXSmall>
      <div className="flex flex-col items-center gap-2">
        <H3 weight="bold" className="text-white">
          {typeof now === 'number' ? toShortNumFormat(now || 0) : now}
        </H3>
        {next && (
          <>
            <ArrowDownIcon className="w-4 h-4 text-white/30 shrink-0" />
            <H3 weight="bold" className="!text-accent">
              {typeof next === 'number' ? toShortNumFormat(next || 0) : next}
            </H3>
          </>
        )}
      </div>
    </div>
  );
};

export { CompareResourceLevelUp };
